import {
  makeStyles, Paper
} from "@material-ui/core";
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import withAdminLayout from "components/HoC/withAdminLayout";
import { format } from "date-fns";
import { boiDepartmentId } from "libs/configs/constant";
import useAdminModalLoading from "libs/hooks/useAdminModalLoading";
import { get } from "lodash";
import SearchFilterBar from "pages/admin/kpi-dashboard/components/SearchFilterBar";
import SummaryPieChart from "pages/admin/kpi-dashboard/components/SummaryPieChart";
import qs from "qs";
import { useEffect, useMemo, useState } from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import { useDispatch, useSelector } from "react-redux";
import "react-resizable/css/styles.css";
import { useHistory } from "react-router-dom";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import DatetimeService from "services/DatetimeService";
import KPIService from "services/KPIService";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  layout: {
    width: "100%",
    height: "100%",
  },
  setting: {
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    padding: "0px 10px",
  },
  rounded: {
    backgroundColor: "dimgray",
    width: "30px",
    height: "30px",
  },
  editMode: {
    display: "flex",
    alignItems: "center",
  },
  editText: {
    marginRight: "15px",
    color: "#2dce98",
    fontWeight: "500",
    fontSize: "16px",
  },
  wrapChart: {
    borderRadius: "9px",
    boxShadow: "0 3px 17px 0 rgb(126 126 126 / 15%)",
    backgroundColor: "white",
    padding: 5,
    paddingBottom: 16
  },
  wrapFilter: {
    display: "flex",
    marginBottom: 15,
  },
}));

const ResponsiveReactGridLayout = WidthProvider(Responsive);
const defaultlayout = [
  // { i: "a", x: 0, y: 0, w: 3, h: 8, isResizable: false },
  // { i: "b", x: 3, y: 0, w: 3, h: 8, isResizable: false },
  // { i: "c", x: 6, y: 0, w: 3, h: 8, isResizable: false },
  // { i: "d", x: 9, y: 0, w: 3, h: 8, isResizable: false },
  { i: "a", x: 0, y: 0, w: 6, h: 10, isResizable: false },
  { i: "b", x: 6, y: 0, w: 6, h: 10, isResizable: false },
  { i: "c", x: 0, y: 0, w: 6, h: 10, isResizable: false },
  { i: "d", x: 6, y: 0, w: 6, h: 10, isResizable: false },

  { i: "e", x: 8, y: 4, w: 4, h: 5, isResizable: false },

  { i: "f", x: 0, y: 9, w: 4, h: 5, isResizable: false },
  { i: "g", x: 4, y: 9, w: 4, h: 5, isResizable: false },
  { i: "h", x: 8, y: 9, w: 4, h: 5, isResizable: false },

  { i: "i", x: 0, y: 14, w: 7, h: 5, isResizable: false },
  { i: "j", x: 7, y: 14, w: 5, h: 5, isResizable: false },
];

const originalLayouts = {};

const textDescription = {
  "ST01": 'Pending > Document Request',
  "ST02": 'Application registered > Consideration by Government Agencies > Qualification approved',
  "ST03": '(Document Review for Visa / WP Issuance) > (IMM / DOE pre-approve visa / WP Issuance)',
  "ST04": '(Visa / WP Issuance Pre approved) > Appointment > Complete',
}

function KPIDashboardPage() {
  const classes = useStyles();
  const history = useHistory()
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState(false);
  const [kpiDashboardData, setKPIDashboard] = useState([]);
  const { showAdminLoading, hideAdminLoading } = useAdminModalLoading();

  const profile = useSelector((state) => state.user.profile);
  const masterData = useSelector(selectMasterData);
  const department = get(masterData, "department", []);

  const flDate = DatetimeService.getFirstAndLastDayOfYear(new Date());
  const [startDate, setStartDate] = useState(flDate.firstDate);
  const [endDate, setEndDate] = useState(flDate.lastDate);
  const [empId, setEmpId] = useState(null);
  const [departmentId, setDepartmentId] = useState(null);

  const [layout, setlayout] = useState(
    JSON.parse(JSON.stringify(originalLayouts))
  );

  const onLayoutChange = async (layout, layouts) => {
    setlayout(layouts);
  };

  const _startDate = startDate ? format(new Date(startDate), "yyyy-MM-dd") : undefined;
  const _endDate = endDate ? format(new Date(endDate), "yyyy-MM-dd") : undefined;

  const params = {
    startDate: _startDate,
    endDate: _endDate,
    empId: empId || undefined,
    departmentId: departmentId || undefined,
  }

  const getData = async () => {
    const res = await KPIService.getKPIDashboard(params)
    setKPIDashboard(res.results)
  }

  useState(() => {
    if (history.location.state?.departmentId) {
      setDepartmentId(history.location.state?.departmentId)
    }

    if (history.location.state?.startDate) {
      setStartDate(new Date(history.location.state?.startDate))
    }

    if (history.location.state?.endDate) {
      setEndDate(new Date(history.location.state?.endDate))
    }

  }, [history.location.state])

  useEffect(() => {
    getData()
  }, [])

  useEffect(() => {
    async function mergedFetchData() {
      await dispatch(
        getMasterData({
          department: true,
        })
      );
    }
    mergedFetchData();
  }, [dispatch]);

  const handleSearch = async () => {
    showAdminLoading();
    await getData();
    hideAdminLoading();
  };

  const departmentList = useMemo(() => {
    if (profile.departmentId === boiDepartmentId) {
      return department
    }

    return department.filter((dp) => dp.departmentId === profile.departmentId)
  }, [profile.departmentId, department])

  return (
    <Paper className={classes.paper}>
      <AdminTitle
        title="KPI Dashboard"
      />
      <SearchFilterBar
        department={departmentList}
        showEmployeeField={false}
        startDate={startDate}
        endDate={endDate}
        empId={empId}
        departmentId={departmentId}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        handleSearch={handleSearch}
        setEmpId={setEmpId}
        setDepartmentId={setDepartmentId}
      />
      <ResponsiveReactGridLayout
        className="layout"
        cols={{ lg: 12, md: 12, sm: 2, xs: 2, xxs: 2 }}
        rowHeight={30}
        layouts={layout}
        isDraggable={editMode}
        onLayoutChange={(layout, layouts) => onLayoutChange(layout, layouts)}
        style={{ marginTop: 18 }}
      >
        {kpiDashboardData.map((kpi, i) => (
          <div className={classes.wrapChart} key={defaultlayout[i].i} data-grid={defaultlayout[i]}>
            <SummaryPieChart
              title={`${kpi.stepName} (${kpi.countDay} day)`}
              description={textDescription[kpi.stepKPIID] ?? ''}
              data={[
                {
                  id: 0,
                  label: 'Achieve',
                  value: kpi.achieve,
                  color: '#39d5cf',
                },
                {
                  id: 1,
                  label: 'Not Achieve',
                  value: kpi.notAchieve,
                  color: '#f47560',
                },
              ]}
              onSelectViewAll={() => {
                const queryParams = qs.stringify({
                  ...params,
                  stepName: kpi.stepName,
                  achieve: kpi.achieve,
                  notachieve: kpi.notAchieve
                })
                history.push(`/admin/kpi-dashboard/details/${kpi.stepKPIID}?${queryParams}`)
              }}
            />
          </div>
        ))}
      </ResponsiveReactGridLayout>
    </Paper>
  )
}

export default withAdminLayout(KPIDashboardPage)